const number = (value) =>
  value === null ||
  value === undefined ||
  value === "" ||
  !Number.isFinite(Number(value))
    ? null
    : Number(value);
const decimal = (value) => {
  const n = number(value);
  return n === null ? "未提供" : String(n);
};
const couponBenefit = (coupon) =>
  Number(coupon.discountTypeCode) === 2
    ? number(coupon.paymentRate) === null
      ? "折扣未提供"
      : `${Number((Number(coupon.paymentRate) * 10).toFixed(4))}折`
    : Number(coupon.discountTypeCode) === 1
    ? `${decimal(coupon.discountAmount)}元`
    : "优惠形式未提供";
const couponThreshold = (coupon) =>
  number(coupon.thresholdAmount) === null
    ? "门槛未提供"
    : Number(coupon.thresholdAmount) === 0
    ? "无金额门槛"
    : `满${decimal(coupon.thresholdAmount)}元可用`;
const couponCap = (coupon) =>
  Number(coupon.discountTypeCode) !== 2
    ? ""
    : coupon.maxDiscountAmount === null
    ? "优惠不封顶"
    : number(coupon.maxDiscountAmount) === null
    ? "优惠封顶未提供"
    : `最高优惠${decimal(coupon.maxDiscountAmount)}元`;
const dimensionNames = {
  SERVICE_ITEM: "服务项",
  SERVICE_TYPE: "服务类型",
  THEME_TYPE: "主题类型",
  THEME: "主题",
  STYLE: "风格",
  PACKAGE: "套餐",
  VENUE: "场地",
};
const couponScopeLines = (coupon) => {
  if ((!Array.isArray(coupon.scopes) || !coupon.scopes.length) && (Number(coupon.statusCode) === 2 || coupon.occupied)) return ["适用范围以原预约为准"];
  if (!Array.isArray(coupon.scopes)) return ["适用范围未提供"];
  if (!coupon.scopes.length) return ["当前业务模块全部范围"];
  const lines = coupon.scopes.map((scope) => {
    const dimension =
      dimensionNames[scope.dimension] || scope.dimension || "范围";
    if (scope.matchMode === "ALL") return `全部${dimension}`;
    const mode =
      { INCLUDE: "包含", EXCLUDE: "排除" }[scope.matchMode] || "适用";
    return `${mode}${dimension}：${
      scope.targetName || scope.targetCode || "名称未提供"
    }`;
  });
  if (coupon.businessModule === "PHOTOGRAPHY" && !coupon.scopes.some(scope => scope.dimension === "VENUE")) lines.push("不限场地");
  return lines;
};
// Server LocalDateTime values already use Shanghai time. Do not reparse as browser-local UTC.
const couponValidity = (coupon) =>
  `${coupon.validFrom || "开始时间未提供"} 至 ${
    coupon.expiresAt || "结束时间未提供"
  }（上海时间，截止时刻不含）`;
const couponUseRoute = (coupon) =>
  coupon.businessModule === "PHOTOGRAPHY" && Number(coupon.moduleCode) === 1
    ? "/photograph"
    : null;
module.exports = {
  couponBenefit,
  couponThreshold,
  couponCap,
  couponScopeLines,
  couponValidity,
  couponUseRoute,
};
